import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const AddHeaderModelContent = ({ headerKey, setHeaderKey, headerValue, setHeaderValue }) => {
  return (
    <Box component="form" noValidate autoComplete="off">
      <TextField
        margin="dense"
        label="Key"
        type="text"
        fullWidth
        variant="outlined"
        name="key-name"
        value={headerKey}
        sx={{ mb: 2 }}
        onChange={(e) => {
          setHeaderKey(e.target.value);
        }}
      />
      <TextField
        margin="dense"
        label="Value"
        type="text"
        fullWidth
        variant="outlined"
        multiline
        rows={4}
        name="key-value"
        value={headerValue}
        onChange={(e) => {
          setHeaderValue(e.target.value);
        }}
      />
    </Box>
  );
};

AddHeaderModelContent.propTypes = {
  headerKey: PropTypes.string.isRequired,
  setHeaderKey: PropTypes.func.isRequired,
  headerValue: PropTypes.string.isRequired,
  setHeaderValue: PropTypes.func.isRequired
};

export default AddHeaderModelContent;
